import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core'

import { EditableSelect } from '../../common/EditableComponents'
import { MenuItem } from '@material-ui/core'
import { getLinkIcon, MASTER_CATEGORY, MASTER_PRODUCT } from '../CommonUpdateCells'

export const MCDataDropdownComponent = (props) => {
  const { value, data, colDef } = props

  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = colDef.obj === 'CATEGORY' ? !data.parentCategoryId : !data.masterId
  const masterType = colDef.obj === 'CATEGORY' ? MASTER_CATEGORY : MASTER_PRODUCT
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(masterType, isParent, data, colDef.field)

  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  var dataOptions = props.getDataOptions()
  const fieldName = props.dropDownDataType === 'LabelValue' ? 'label' : 'name'
  const hideSync = props.hideSync || false

  let displayValue = (dataOptions[value] && dataOptions[value][fieldName]) || value
  if (props.multiple) {
    displayValue = []
    value.forEach(function (v) {
      const valueData = (dataOptions[v] && dataOptions[v][fieldName]) || v
      displayValue.push(valueData)
    })
  }

  return (
    <div className="center-item-column">
      <div
        className="align-item-column-value"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
        title={displayValue}
      >
        {displayValue}
      </div>
      {!hideSync && (
      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>)
      }
    </div>
  )
}

export class MCDataDropdownEditor extends Component {
  state = { value: this.props.value }

  handleChange = (event) => {
    let value = event.target.value
    if (this.props.multiple) {
      // remove empty array
      value = value.filter(function (el) {
        return el
      })
    }
    this.setState({ value })
  }
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const { value } = this.state

    const options = this.props.getDataOptionsList()
    const multiple = this.props.multiple || false
    const dropDownDataType = this.props.dropDownDataType || ''

    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableSelect
            editMode={true}
            material={false}
            name={this.props.colDef.field}
            onChange={(event) => this.handleChange(event)}
            value={value}
            multiple={multiple}
            valueToRender={value}
          >
            {dropDownDataType === 'Text'
              ? options.map((entry, index) => {
                  return (
                    <MenuItem key={index} value={entry}>
                      {entry}
                    </MenuItem>
                  )
                })
              : null}
            {dropDownDataType === 'LabelValue'
              ? options.map((entry, index) => {
                  return (
                    <MenuItem key={index} value={entry.value}>
                      {entry.label}
                    </MenuItem>
                  )
                })
              : null}
            {dropDownDataType === ''
              ? options.map((entry, index) => {
                  return (
                    <MenuItem key={index} value={entry.id}>
                      {entry.name}
                    </MenuItem>
                  )
                })
              : null}
          </EditableSelect>
        </div>
      </div>
    )
  }
}

export default {
  MCDataDropdownComponent,
  MCDataDropdownEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCDataDropdownComponent.js